<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex; justify-content: space-between">
        <button-add
          :pathName="addController"
          v-if="permissionCodes.indexOf('004009001') !== -1"
        />
        <button-delete @deleteSelection="deleteSelection" v-if="permissionCodes.indexOf('') !== -1" />
        <!--<button-upload-->
        <!--:cathUrl="uploadUrl"-->
        <!--:onSuccess="onUploadSuccess"-->
        <!--@getpage="getPage"-->
        <!--v-if="permissionCodes.indexOf('004004010') !== -1"-->
        <!--value="导入"/>-->
      </div>
      <div style="display: flex; justify-content: flex-end">
        <input-search placeholder="车主姓名/车牌号" @search="searchKey" />
        <button-export
          style="margin-left: 5px"
          :href="exportUrl"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('004009004') !== -1"
          download="download.xls"
          value="导出"
        />
      </div>
    </div>
    <div class="search-line">
      <div style="display: flex; justify-content: space-between">
        <input-select selectTitle="车辆类型" :selectKey="'parkingType'" :selectData="parkingTypeList" @search="search" style="margin-right: 10px"/>
        <span style="margin-right: 10px;">进场时间</span>
        <el-date-picker
          v-model="timevalue"
          size="small"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        <div style="display: flex;justify-content: flex-start;align-items: center;margin-left: 10px;">
          <span style="color: #666666;margin-right: 5px">停留时间超过</span>
          <el-input
            v-model="requestData.overNDays"
            size="small"
            style="width: 120px;"
            class="payDeadInput"
            type="number"
            @keyup.native.13="changeDeadCount"
          >
            <template slot="append">天</template>
          </el-input>
        </div>
      </div>
    </div>
    <table-main
      :tableHead="tableHead"
      :tableData="tableData"
      :total="total"
      :pageNum="pageNum"
      :pageSize="pageSize"
      @deleteLine="deleteLine"
      @goToModifyPage="goToModifyPage"
      @changePagination="changePagination"
      :operationArr="operationArr"
      :deleteTipInfo="'是否确认删除在场车辆？'"
      @changeSelection="changeSelection"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "vehicles-on-site",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "在场车辆"
        }
      ],
      addController: "vehicles-on-site-add",
      exportUrl: "",
      uploadUrl: "",
      tableHead: [
        {
          prop: "carNumber",
          label: "车牌号"
        },
        {
          prop: "carOwnerName",
          label: "车主姓名"
        },
        {
          prop: "carOwnerPhone",
          label: "车主手机号"
        },
        {
          prop: "parkingTypeText",
          label: "车辆类型"
        },
        {
          prop: "carAccessTime",
          label: "进场时间"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        orderByCarAccessTime: null,
        parkingType:"",
        startTime:"",
        endTime:"",
        overNDays:0
      },
      parkingTypeList:[
        { key: "", label: "全部" },
        { key: "1", label: "包月" },
        { key: "2", label: "临停" },
        { key: "3", label: "无牌" },
        { key: "4", label: "白名单" }
      ],
      operationArr: ["modify", "delete"],
      timevalue: [],
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.uploadUrl = api.importAuthority;
    // this.exportUrl = `${api.exportAuthority}?yq-app-code=${bus.global.yqCode}&kj-type=gy`
    this.getCreateTime();
  },
  activated() {
    this.getCreateTime();
  },
  methods: {
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-" + date + " " + "00:00:00";
      this.timevalue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    beforeDownload() {
      this.exportUrl = `${api.exportParkingPresentCar}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&parkingType=${this.requestData.parkingType}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}&overNDays=${this.requestData.overNDays}`;
    },
    // 获取分页
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || "";
        this.requestData.endTime = this.timevalue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getParkingPresentCarPage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            if (v.parkingType === "1") {
              v.parkingTypeText = "包月";
            } else if (v.parkingType === "2") {
              v.parkingTypeText = "临停";
            } else if (v.parkingType === "3") {
              v.parkingTypeText = "无牌";
            } else if (v.parkingType === "4") {
              v.parkingTypeText = "白名单";
            }
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取数据失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `/park_server/vehicles_on_site_modify/${code}`
      });
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteParkingPresentCar, code)
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    },
    handleSortChange(data){
      switch (data.order) {
        case 'ascending':
          data.order = 'asc';
          break;
        case "descending":
          data.order = 'desc';
          break;
        default:
          data.order = null;
      }
      this.requestData.orderByCarAccessTime = data.order;
      this.getPage();
    },
    changeDeadCount() {
      this.pageNum = 1;
      this.getPage();
    },
    deleteSelection () {
      if (this.selectionArr.length === 0) {
        nAlert('请先选择需要删除的在场车辆')
        return false
      } else {
        this.$confirm('是否确认删除在场车辆？', '提示')
          .then(() => {
            this.deleteLine(this.selectionArr)
          })
          .catch(() => {
            console.log('取消删除')
          })
      }
    },
    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
  },
  watch: {
    timevalue(val) {
      this.getPage();
    },
    "requestData.overNDays"(val) {
      this.pageNum = 1;
      this.requestData.overNDays=+val
      this.getPage();
    },
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/VehiclesOnSite/VehiclesOnSite.vue